module.exports = __webpack_public_path__ + "img/video-instruction-banner.cafa9129.png";